// Manually curated Waavo charter offers for the home page carousel — same idea as Kolumbs'
// admin "Waavo Carousel" tool (paste a Waavo URL, fill in title/price/image/link), just without
// the admin UI yet. Add/remove entries here by hand until the backend "Fill from API" proxy
// exists; the carousel component itself won't need to change when that lands.
//
// Shape per entry:
//   id        — anything unique, e.g. the Waavo hotel/offer id from its URL
//   title     — destination name
//   badge     — small label shown over the photo (e.g. "Populāra izvēle")
//   badgeTone — one of "rose" | "sky" | "mint" | "amber" | "violet" — picks the badge's color
//   nights    — number of nights
//   meal      — meal plan text (e.g. "All Inclusive")
//   departure — departure text (e.g. "No Rīgas")
//   price     — number, per-person price in EUR (no currency symbol)
//   image     — direct image URL (from the Waavo offer page)
//   link      — the Waavo offer URL to send the user to on click
//
// TEMPORARY dev placeholders below (stock photos, not real live offers) so the section can be
// reviewed — swap for real Waavo data (or clear the array) before this goes live.
// No per-destination Waavo link exists for these mock entries yet, so they point at the general
// charter search page (/charter-flights) rather than being dead/unclickable — swap each `link`
// for the real per-offer Waavo URL once one exists.
export const charterDeals = [
  {
    id: "dev-egypt",
    title: "Ēģipte",
    badge: "Populāra izvēle",
    badgeTone: "rose",
    nights: 7,
    meal: "All Inclusive",
    departure: "No Rīgas",
    price: 399,
    image: "https://images.unsplash.com/photo-1553913861-c0fddf2619ee?w=500&h=400&fit=crop",
    link: "/charter-flights",
  },
  {
    id: "dev-tenerife",
    title: "Tenerife",
    badge: "Lieliskais klimats",
    badgeTone: "sky",
    nights: 7,
    meal: "Brokastis + vakariņas",
    departure: "No Rīgas",
    price: 549,
    // The original Tenerife-specific stock photo 404'd — verified this one loads and is a real
    // coastal-resort photo (not literally Tenerife), a stand-in until a real Waavo photo exists.
    image: "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=500&h=400&fit=crop",
    link: "/charter-flights",
  },
  {
    id: "dev-dubai",
    title: "Dubaija",
    badge: "Ekskluzīvs galamērķis",
    badgeTone: "mint",
    nights: 7,
    meal: "Brokastis",
    departure: "No Rīgas",
    price: 699,
    image: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=500&h=400&fit=crop",
    link: "/charter-flights",
  },
  {
    id: "dev-turkey",
    title: "Turcija",
    badge: "Izdevīgs piedāvājums",
    badgeTone: "amber",
    nights: 7,
    meal: "All Inclusive",
    departure: "No Rīgas",
    price: 449,
    // Original URL 404'd — replaced with a verified, genuinely Istanbul/Turkey photo.
    image: "https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?w=500&h=400&fit=crop",
    link: "/charter-flights",
  },
  {
    id: "dev-vietnam",
    title: "Vjetnama",
    badge: "Unikāla pieredze",
    badgeTone: "violet",
    nights: 10,
    meal: "Brokastis + vakariņas",
    departure: "No Rīgas",
    price: 949,
    image: "https://images.unsplash.com/photo-1528127269322-539801943592?w=500&h=400&fit=crop",
    link: "/charter-flights",
  },
];
